export const currencies = [
  { currency: 'USD', flag: 'US' },
  { currency: 'CUP', flag: 'CU' },
  { currency: 'CUC', flag: 'CU' },
  { currency: 'MXN', flag: 'MX' },
  { currency: 'EUR', flag: 'EU' },
  { currency: 'VEF', flag: 'VE' },
  { currency: 'BRL', flag: 'BR' },
  { currency: 'CAD', flag: 'CA' },
  { currency: 'GBP', flag: 'GB' },
  { currency: 'COP', flag: 'CO' },
  { currency: 'BOB', flag: 'BO' },
  { currency: 'ARS', flag: 'AR' },
  { currency: 'PEN', flag: 'PE' },
  { currency: 'CLP', flag: 'CL' },
  { currency: 'DOP', flag: 'DO' },
  { currency: 'CRC', flag: 'CR' },
  { currency: 'SVC', flag: 'SV' },
  { currency: 'GTQ', flag: 'GT' },
  { currency: 'GYD', flag: 'GY' },
  { currency: 'HTG', flag: 'HT' },
  { currency: 'HNL', flag: 'HN' },
  { currency: 'JMD', flag: 'JM' },
  { currency: 'NIO', flag: 'JM' },
  { currency: 'PAB', flag: 'PA' },
  { currency: 'PYG', flag: 'PY' },
  { currency: 'SRD', flag: 'SR' },
  { currency: 'TTD', flag: 'TT' },
  { currency: 'UYU', flag: 'UY' },
  { currency: 'BSD', flag: 'BS' },
  { currency: 'BBD', flag: 'BB' },
]
